import { RenewVisaHistoryEmployeeApplicationPage } from "@/features/renew-visa/pages/RenewVisaHistoryEmployeeApplication";

const RenewVisaHistoryEmployeeApplication = () => {
  return <RenewVisaHistoryEmployeeApplicationPage />;
};

export default RenewVisaHistoryEmployeeApplication;
